import http from "src/shared/http";

interface HttpQueryParams {
  url: string;
  method?: string;
  body?: object;
  params?: object;
}

const httpBaseQuery =
  () =>
  ({ url, method = "get", body, params }: HttpQueryParams) => {
    try {
      return http(url, { method, body, params });
    } catch (error) {
      return {
        error,
      };
    }
  };

export default httpBaseQuery;
